export const PERMISSION_REQUEST = "PERMISSION_REQUEST";
export const PERMISSION_SUCCESS = "PERMISSION_SUCCESS";
export const PERMISSION_FAIL = "PERMISSION_OWNER_FAIL";
export const PERMISSION_CLEAR_ERRORS = "PERMISSION_CLEAR_ERRORS";
